import els from './elements';

const TEXT_SLIDE_DURATION = 0.75;

let context = null;

const initialize = () => {

    const $hero = els.$hero();
    const $overlay = els.$overlay();
    const $overlayText = els.$overlayText();

    const initialY = $overlay.outerHeight() * 0.54; // The bottom part of the graphic is ~54% of overhall height

    let scrollTriggered = false;

    context = gsap.context(() => {

        gsap.set(
            $overlay,
            { y: initialY }
        );

        gsap.to($overlay, { autoAlpha: 1 });

        gsap.to(
            $overlay,
            {
                y: 0,
                duration: TEXT_SLIDE_DURATION,
                scrollTrigger: {
                    trigger: $hero,
                    start: 'top top-=100',
                },
                onStart: () => {
                    scrollTriggered = true;
                },
            }
        );
    });

    $overlayText.on('mouseenter', () => {

        if (scrollTriggered) return;

        gsap.to(
            $overlay,
            {
                y: 0,
                duration: TEXT_SLIDE_DURATION,
            }
        );
    });

    $overlayText.on('mouseleave', () => {

        if (scrollTriggered) return;

        gsap.to(
            $overlay,
            {
                y: initialY,
                duration: TEXT_SLIDE_DURATION,
            }
        );
    });
};

const cleanUp = () => {

    context?.revert();
};

export default {
    initialize,
    cleanUp,
};

